import styled from "styled-components";

export const CarouselWrapper = styled.div`
  position: relative;

  .slick-track {
    display: flex;
    gap: 16px;
  }

  .slick-dots .slick-active > div {
    background: #032e68;
  }

  .slick-dots-bottom {
    bottom: -24px;
  }
`;

export const CarouselDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid #032e68;
  background: white;
  cursor: pointer;
`;

export const Task = styled.button<{ disabled?: boolean }>`
  border-radius: 10px;
  padding: 30px 25px;
  text-align: left;
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  border: 1.5px solid rgba(51, 51, 51, 0.15);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);

  ${({ disabled }) =>
    disabled
      ? `
  pointer-events: none;
      `
      : `
  background: white;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 4px 6px rgba(51, 51, 51, 0.25);
  }
  `}
`;

export const TaskCheck = styled.div`
  border-radius: 50%;
  border: 2px solid #10b981;
  font-size: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  color: #10b981;

  .anticon {
    width: 32px;
  }
`;
